module.exports = __webpack_public_path__ + "static/media/10.126d7ddc.jpg";